const makeConstant = constant => `state/${constant}`

export const FETCH_ONBOARDING_STATUS = makeConstant('FETCH_ONBOARDING_STATUS')
export const FETCH_ONBOARDING_STATUS_SUCCESS = makeConstant('FETCH_ONBOARDING_STATUS_SUCCESS')
export const FETCH_ONBOARDING_STATUS_FAILED = makeConstant('FETCH_ONBOARDING_STATUS_FAILED')

export const PATCH_ONBOARDING_STATUS = makeConstant('FETCH_ONBOARDING_STATUS')
export const PATCH_ONBOARDING_STATUS_SUCCESS = makeConstant('FETCH_ONBOARDING_STATUS_SUCCESS')
export const PATCH_ONBOARDING_STATUS_FAILED = makeConstant('FETCH_ONBOARDING_STATUS_FAILED')


// WEBPACK FOOTER //
// ./src/modules/state/constants.js